<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Filing Date</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{filingDate}}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Applicant Name</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{  getApplicantName() }}</div>
</div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Qualification Type</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{  getQualificationType() }}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Date of Birth</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{  this.getValue('QualificationTab', 'birthDate') | date: 'MM/dd/yyyy'  }}
  </div>
</div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">FEIN</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{  this.getValue('QualificationTab', 'fein') | mask:'00-0000000'}}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Email</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{  this.getValue('QualificationTab', 'contactEmail') }}</div>
</div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Entity Control #</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{this.getValue('QualificationTab', 'entityControlNumber')}}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Phone</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{ this.getValue('QualificationTab', 'contactPhone') | mask: '(000)000-0000' }}</div>
</div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Business Entity Name</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{this.getValue('QualificationTab', 'filingEntityName')}}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Last 4 SSN</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{ this.getValue('QualificationTab', 'lastFourSocialSecurityNumber') }}</div>
</div>
<div class="bottom-line"></div>

<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Mailing Address</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{getMailingAddress()}}</div>
  <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Physical Address</div>
  <div class="col-lg-3 col-md-3 col-sm-6">{{ getPhysicalAddress() }}</div>
</div>
<div class="bottom-line"></div>
<div class="row">
  <div class="col-lg-9 col-md-9 col-sm-9" style="text-align: start;">{{licenseContractorsText}}</div>
  <div class="col-lg-3 col-md-3 col-sm-3">{{ CsPLicense == null ? 'Yes' : 'No'}}</div>
</div>
<div class="row">
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">State License #</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ this.getValue('LicenseTab', 'stateLicenseNumber') }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
  <div class="col-lg-2 col-md-3 col-sm-6">
    {{ this.getValue('LicenseTab', 'stateLicenseExpirationDate') | date: 'MM/dd/yyyy' }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Contractor Service Provider #</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ CsPLicense?.licenseNumber }}</div>
</div>
<div class="bottom-line"></div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-9" style="text-align: start;">County Business License</div>
</div>
<div class="row">
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">County License #</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ this.getValue('LicenseTab', 'countyLicenseNumber') }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
  <div class="col-lg-2 col-md-3 col-sm-6">
    {{ this.getValue('LicenseTab', 'countyLicenseExpirationDate') | date: 'MM/dd/yyyy' }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">County</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ this.getCounty(this.getValue('LicenseTab', 'county')) }}</div>
</div>
<div class="bottom-line"></div>
<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-9" style="text-align: start;">City Business License</div>
</div>
<div class="row">
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">City License #</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ this.getValue('LicenseTab', 'cityLicenseNumber') }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
  <div class="col-lg-2 col-md-3 col-sm-6">
    {{ this.getValue('LicenseTab', 'cityLicenseExpirationDate') | date: 'MM/dd/yyyy' }}</div>
  <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">City</div>
  <div class="col-lg-2 col-md-3 col-sm-6">{{ this.getCity(this.getValue('LicenseTab', 'city')) }}</div>
</div>
<div class="bottom-line"></div>
<form class="qualification-tab-form" [formGroup]="ConfirmationTab">
  <div *ngIf="stillAffCbFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" formControlName="stillAffiliated" class="mailingAddress">{{stillAffiliatedCheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="!regApFtype.includes(FillingType) && !checkAttestTCA()" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" formControlName="attestToTCA" class="mailingAddress">{{attestToTCACheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="checkAttestTCA()" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" formControlName="attestToTCA" class="mailingAddress">{{attestToTCA903CheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="rightSueFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" formControlName="waveRightToSue" class="mailingAddress">{{waveRightsToSueCheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="regApFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" formControlName="registeredApplicant" class="mailingAddress">{{registeredApplicantCheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="doHvInjutyFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [checked]="injuryMode" [required]="IsExternal" (change)="onCheck(true, $event)"  [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" class="mailingAddress">{{yesHaveInjuryCheckBox}}</mat-checkbox>
  </div>
  <div *ngIf="doHvInjutyFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
    <mat-checkbox [checked]="injuryMode != null && !injuryMode" [required]="IsExternal" [ngClass]="ConfirmationTab.controls['waveRightToSue'].invalid ? 'errorMsg' : ''" (change)="onCheck(false, $event)" class="mailingAddress">{{dontHaveInjuryCheckBox}}</mat-checkbox>
  </div>
  <div class="bottom-line"></div>
</form>
